import type { InvestigationExport } from "@/app/providers/services";

export const INVESTIGATION_EXPORT_FORMAT = "decisively-investigations";

/** Download name for an export; `downloadFile` sanitizes it, so names can be used as-is. */
export function investigationExportFileName(payload: InvestigationExport, scope: "page" | "all"): string {
  const project = payload.source.modelName || "project";
  if (scope === "all") return `${project} - investigations.json`;
  return `${project} - ${payload.investigations[0]?.name || "investigation"}.json`;
}

/**
 * Parse an uploaded export just far enough to confirm what will be imported. The server
 * validates the full payload (card types, sizes, saved state) before anything is written.
 */
export function parseInvestigationExport(text: string): InvestigationExport {
  let payload: unknown;
  try {
    payload = JSON.parse(text);
  } catch {
    throw new Error("This file is not valid JSON");
  }
  const candidate = payload as Partial<InvestigationExport> | null;
  if (!candidate || typeof candidate !== "object" || candidate.format !== INVESTIGATION_EXPORT_FORMAT) {
    throw new Error("This file is not an investigation export");
  }
  if (!Array.isArray(candidate.investigations) || candidate.investigations.length === 0) {
    throw new Error("The export does not contain any investigations");
  }
  return candidate as InvestigationExport;
}

/** Prefer the server's public message (e.g. a validation failure) over a generic fallback. */
export function transferErrorMessage(error: unknown, fallback: string): string {
  const candidate = error as { response?: { data?: { message?: unknown } }; message?: unknown } | undefined;
  const message = candidate?.response?.data?.message ?? candidate?.message;
  return typeof message === "string" && message.trim() ? message : fallback;
}
